import React from 'react';
import {Await, useLoaderData} from '@remix-run/react';
import {Suspense} from 'react';

//components
import ProductsMarquee from 'components/modules/ProductsMarquee';

import {loader} from '~/routes/($lang)/index';

/**
 * 預訂產品 marquee under the featured-products one. Products come from
 * the Shopify `preorder-products` collection (the same source as
 * /collections/preorder-products), so the section stays in sync with the
 * pre-order page without any CMS work; the localized collection title is
 * used as the heading.
 */
export default function PreorderProducts() {
  const {preorderProducts, preorderCollectionTitle} =
    useLoaderData<typeof loader>();

  if (!preorderProducts) return <></>;
  return (
    <Suspense fallback="loading">
      <Await resolve={preorderProducts}>
        {(products) => {
          if (!products) return <></>;
          return (
            <ProductsMarquee
              title={preorderCollectionTitle ?? '預訂產品'}
              products={products}
              viewAllTo="/collections/preorder-products"
              className="!pt-4"
            />
          );
        }}
      </Await>
    </Suspense>
  );
}
